import React from 'react';
import { Dialog, DialogContent } from './components/ui/dialog';
import { CircularProgress } from './components/ui/progress';

const LoadingModal = ({ open, message }) => {
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="bg-white/90 shadow-none p-6" hideClose>
        <div className="flex flex-col items-center justify-center p-4">
          <CircularProgress size={40} className="mb-4" />
          <h2 className="text-lg font-semibold text-center mb-2">
            Loading Shipment Data
          </h2>
          <p className="text-sm text-center text-gray-600">
            {message}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LoadingModal; 